meedy.controller('meedy.errorNotFoundController', ['$scope', '$state', 'meedy.objectHelper', 'applicationModel',
    function ($scope, $state, objectHelper, applicationModel) {

        function setData() {
        }

        function setPermissions() {
        }

        function setListeners() {
            $scope.$on('$destroy', function (event) {
                applicationModel.viewReady = false;
            });
        }

        function setActions() {
        }

        function configureInterface() {
            applicationModel.deselectSideBarItems();

            applicationModel.setTitleBar('T.MEEDY.SYSTEM.ERROR.ERROR');
        }

        function initialize() {
            applicationModel.viewReady = true;
        }

        setData();
        setPermissions();
        setListeners();
        setActions();
        configureInterface();
        initialize();
    }
]);
